import { render, staticRenderFns } from "./registerElement.vue?vue&type=template&id=7d21ac48&scoped=true"
import script from "./registerElement.vue?vue&type=script&lang=js"
export * from "./registerElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d21ac48",
  null
  
)

export default component.exports